module.exports = ".w-210 { width: 210px; /*210px * 0.0625*/}\n\n.print-gly { color: #40A9F5; }\n\n.print-gly:hover{\n  cursor: pointer;\n  color: #6AC5FF;\n}\n\n.hidden {\n  display: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/hospital-profile/hospital-profile.component.css
// module id = ./src/app/profile/hospital-profile/hospital-profile.component.css
// module chunks = main